/* ============================================================================
   MoveOn PDP — behaviour
   ----------------------------------------------------------------------------
   Vanilla port of the `class Component extends DCLogic` script in the Claude
   Design comp `MoveOn PDP.dc.html`. No framework, no support.js: the comp's
   `{{ }}` bindings become data-attribute hooks + the state classes in pdp.css.
   ============================================================================ */
(function () {
  'use strict';

  var F = 'https://immority.store/cdn/shop/files/';
  /* The Shopify section emits window.MO_PDP_ASSETS mapping each basename to its
     asset_url (theme assets get hashed CDN URLs, so no shared base path exists).
     Standalone, the map is absent and we fall back to the on-disk folder. */

  /* ==========================================================================
     CHECKOUT BRIDGE (Shopify build only)
     The add-to-cart button and drawer stay exactly as designed — the drawer is a
     mock and holds nothing but local state. The real Shopify cart is populated
     once, at Checkout, from the bundle/plan the shopper actually chose.

     Appstle patches window.fetch and injects its own name="selling_plan" radios;
     its radios win over anything we send, so they are driven directly here and
     its widget is hidden by pdp.css.
     ========================================================================== */
  var SKUS = [
    { variant: 46917573771505, plan: 5251432689 },  /* 1 Box   $87 / $79  every 16 days */
    { variant: 46917573804273, plan: 5251465457 },  /* 2 Boxes $146 / $130 every 30 days */
    { variant: 46917573837041, plan: 5251498225 }   /* 3 Boxes $199 / $177 every 45 days */
  ];

  function syncAppstle() {
    var want = st.plan === 'sub' ? String(SKUS[st.bundle].plan) : '';
    var picked = null;
    document.querySelectorAll('input[name="selling_plan"]').forEach(function (r) {
      if (r.value === want && !picked) picked = r;
      r.checked = false;
    });
    if (picked) {
      picked.checked = true;
      picked.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var checkingOut = false;

  /* Back-button recovery. goToCheckout() latches `checkingOut` and disables the
     button before redirecting; pressing Back restores this page from the
     bfcache with that JS state intact, so the button stayed dead and the
     shopper could not check out again. pageshow fires on every restore. */
  function releaseCheckout() {
    checkingOut = false;
    document.querySelectorAll('[data-checkout]').forEach(function (el) {
      el.style.pointerEvents = '';
      el.style.opacity = '';
    });
  }
  window.addEventListener('pageshow', releaseCheckout);
  window.addEventListener('popstate', releaseCheckout);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) releaseCheckout();
  });

  function goToCheckout(trigger) {
    if (checkingOut) return;
    checkingOut = true;
    if (trigger) { trigger.style.pointerEvents = 'none'; trigger.style.opacity = '.7'; }

    syncAppstle();
    var m = SKUS[st.bundle];
    var item = { id: m.variant, quantity: (st.cart && st.cart.qty) || 1 };
    if (st.plan === 'sub') item.selling_plan = m.plan;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* clear first so repeated adds from the mock drawer cannot stack up */
    /* Appstle patches window.fetch AND XMLHttpRequest and re-renders its
       selling_plan radios asynchronously after any cart change, so a scripted
       add loses the race and a Subscribe order silently lands one-time (seen
       live). A NATIVE form POST to /cart/add bypasses both patches, keeps the
       same cart (affiliate_id attribute survives), and return_to lands the
       shopper on checkout. */
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .catch(function () {})
      .then(function () {
        var f = document.createElement('form');
        f.method = 'POST';
        f.action = root + 'cart/add';
        f.style.display = 'none';
        var add = function (k, v) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = k; i.value = v;
          f.appendChild(i);
        };
        add('id', String(m.variant));
        add('quantity', String((st.cart && st.cart.qty) || 1));
        if (st.plan === 'sub') add('selling_plan', String(m.plan));
        add('return_to', '/checkout');
        document.body.appendChild(f);
        f.submit();
      });
  }

  var ASSETS = window.MO_PDP_ASSETS || null;
  function asset(n) { return (ASSETS && ASSETS[n]) || 'assets/img/pdp/' + n; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)); };
  var esc = function (s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };
  /* comp helper: local upload paths pass through, CDN files get ?v=&width= */
  var cdn = function (file, v, w) {
    return file.charAt(0) === '@' ? asset(file.slice(1)) : F + file + '?v=' + v + '&width=' + (w || 1400);
  };

  /* ==========================================================================
     DATA — verbatim from the comp
     ========================================================================== */

  var bundleData = [
    { title: '1 Box', servings: '16 servings', was: 107, price: 87, sub_price: 79, extra: 10, save: 20 },
    { title: '2 Boxes', servings: '32 servings', was: 214, price: 146, sub_price: 130, extra: 17, save: 68 },
    { title: '3 Boxes', servings: '48 servings', was: 319, price: 199, sub_price: 177, extra: 25, save: 120 }
  ];

  var gallery = [
    asset('gallery-1.webp'), asset('gallery-2.webp'), asset('gallery-3.webp'), asset('gallery-4.webp'),
    asset('gallery-5.webp'), asset('gallery-6.webp'), asset('gallery-7.webp'), asset('gallery-8.webp')
  ];

  var press = [
    ['logo-healthline.svg', '1765600287', 'Healthline'],
    ['fda_1.png', '1774162522', 'FDA registered facility'],
    ['Wellergy_Formulation_Logo_Colour_1.webp', '1774162430', 'Wellergy formulation'],
    ['nih-logo-1.webp', '1774162654', 'NIH'],
    ['Product_by_Wellous_Logo_1.webp', '1774162430', 'Product by Wellous'],
    ['logo-harvard.webp', '1765600467', 'Harvard']
  ];

  var expertData = [
    ['Dr. Elena Foster', 'Licensed physical therapist &amp; wellness coach', '297823a5-4142-4777-a64a-4633d8c33cbb-2_360x360.jpg', '1768383001', '2d8a05504b96455a9b59eaf3ecfec6c9', '66948070'],
    ['Simon Vance', 'MSc Clinical Nutrition · board-certified nutrition specialist', '614444a2-f7f8-4b01-89ec-84cc3100cceb-2_360x360.jpg', '1768383001', '7acbeba9855a4f3a87a8a767983d94ce', '66948519'],
    ['Dr. Evelyn Reed', 'Orthopedic specialist &amp; integrative bone health expert', '55c417d0-eacd-4eae-a12e-b97fcb1c6f5e-2_360x360.jpg', '1768383001', 'd3a51dcedbc946fda9e4e782158b4bb5', '66948939'],
    ['Carmen Davies', 'Certified nutrition specialist &amp; longevity expert', '53e5173e-5bef-4a99-b5c8-66bcc7fd3b30-2_360x360.jpg', '1768383002', 'e450ec3fd5be4267a0163d9c9e0584f9', '66949302'],
    ['Emily Collier', 'Holistic clinical nutritionist &amp; women’s health advocate', 'c800644b-9770-49f0-b01c-98c12180ee27-2_360x360.jpg', '1768383001', 'f0064a12e84347a1ae46ad1617911264', '66949847']
  ];

  var reviewData = [
    [5, '50% less pain and swelling in just 2 weeks', 'My right knee has been really painful, swollen and sore. I used to walk my dogs, but I couldn’t do it any more because of the pain. After 2 weeks of taking MoveOn, the pain and swelling decreased by about 50%. I can walk much better.', 'Evelyn Hipple'],
    [5, 'Easy to use, real results', 'Simple to use and I feel a difference in my body in a positive way. I fractured my pelvis a year and a half ago and still have some aches and pains. Thanks.', 'Peter Hartmann'],
    [5, 'I’m moving again and I can’t believe it', 'I love it. It has given me hope and a lot more confidence than I thought I would have. It’s so beautiful to be able to move around again. Thank you for an amazing product.', 'Queen Okeoma'],
    [5, 'Worth every penny', 'I have been dealing with excruciating pain from the bone on bone in my knees. I have spent a small fortune on pain creams and infrared devices that were supposed to work miracles. I can’t thank your company enough for this product. The relief has been undeniable.', 'Deborah Jones'],
    [5, 'The pain just stopped', 'Great product. I was in pain daily and I was trying everything. Once I started using the product the pain stopped after usage.', 'Jerome Jones'],
    [4, 'When you have sciatica and osteoarthritis', 'I was told I have bilateral sciatica and osteoarthritis on both hips. It has been pretty painful just moving around and I’ve been trying many different options trying to find relief. I’m on day 7 with this product and I definitely notice and feel the difference.', 'Steve Pukini'],
    [5, 'Back at the gym with no pain', 'I ordered 2 boxes and I’m almost out waiting for my new shipment. MoveOn has given the spark back in my knees. It has taken several weeks, but these last few days I’ve been able to walk normally. I even rode the stationary bike and did a few leg machines, no pain.', 'Ilona Hagen'],
    [4, 'Better, and I’m not stopping', 'I’m just starting on my second box. The knees are feeling a little better but it’s not there yet. I’m going to order more. I’ll let you know after 90 days how my knees feel.', 'Rochelle Herring']
  ];

  var ugcFiles = [
    asset('ugc-1.webp'), asset('ugc-2.webp'), asset('ugc-3.webp'),
    ['3eec4cdb-1460-42f3-8bbc-a6a81e9e85b7.webp', '1766743237'],
    ['b62f86bd-92c9-48e2-b6aa-6cde23e88a1e.webp', '1766743486'],
    ['6e975331-d3fa-426b-80f1-49b9c290b820.webp', '1766743486'],
    ['ec53bbbe-8a66-4359-96cd-f14ba15bdf0a.webp', '1766743236'],
    ['513b7f26-0f1f-447f-ae14-771a61c0d24c.webp', '1766743236'],
    ['69592274-add0-45b4-914d-be719bb5c2ab.webp', '1766743237'],
    ['a664d2d4-b040-45d7-9964-fdabc54c101e.webp', '1766743237'],
    ['27d2063f-c21d-4a72-8c49-1754f6e3f61b.webp', '1766743486']
  ];

  var rivals = [
    { name: 'Glucosamine + chondroitin', covered: 2, coverText: '2 of 5: cartilage, fluid' },
    { name: 'Collagen peptides', covered: 2, coverText: '2 of 5: bone, tendon' },
    { name: 'Osteo Bi-Flex®', covered: 2, coverText: '2 of 5: cartilage, fluid' },
    { name: 'MSM', covered: 1, coverText: '1 of 5: comfort' },
    { name: 'Turmeric + black pepper extract', covered: 1, coverText: '1 of 5: inflammation' }
  ];

  var compData = [
    ['What it targets', 'Five joint systems', 'One daily sachet', [['Cartilage matrix', 'Raw building blocks'], ['Connective tissue', 'Protein supply'], ['Comfort blend', 'Glucosamine, chondroitin, MSM'], ['Comfort', 'Sulfur donor'], ['Inflammation', 'Curcuminoids + piperine']]],
    ['Cartilage repair', 'Yes', 'UC-II® 40 mg + Ovomet®', [['Mixed evidence', 'Modest at best in trials'], ['Indirect', 'Feeds the matrix, no signal'], ['Mixed evidence', 'Same actives, tablet form'], ['Not targeted', 'Comfort, not structure'], ['Not targeted', '']]],
    ['Bone density', 'Yes', 'BonePep™ + D3', [['Not included', ''], ['Some evidence', 'Peptides studied for bone'], ['Not included', ''], ['Not included', ''], ['Not included', '']]],
    ['Tendon &amp; ligament', 'Yes', 'Ovomet® collagen and elastin', [['Not targeted', ''], ['Yes', 'Studied for tendon load'], ['Partial', 'Via MSM'], ['Some evidence', 'Soreness and recovery'], ['Not targeted', '']]],
    ['Inflammation', 'Yes', 'Turmeric + ovotransferrin', [['Limited', ''], ['Limited', 'CRP fell in one trial'], ['Limited', ''], ['Moderate', 'Lowers pain scores'], ['Best in class', 'The strongest single active here']]],
    ['Absorption', 'Pre-dissolved', 'Nothing to break down first', [['Variable', 'Chondroitin under 20%'], ['Good', 'Peptides absorb readily'], ['Variable', 'Coated tablet'], ['High', 'Absorbs readily'], ['Low without help', 'Piperine lifts it sharply']]],
    ['Daily format', '1 sachet', 'No water, no pills', [['2 to 4 tablets', ''], ['Scoop of powder', 'Needs mixing'], ['2 tablets', ''], ['3 to 6 g powder', ''], ['1 to 2 capsules', '']]]
  ];

  var compExtra = {
    0: [
      ['How it acts', 'Signal and substrate', 'Retrains the immune attack, then feeds the matrix', [['Substrate only', 'Supplies raw GAG precursors'], ['Substrate and signal', 'Pro-Hyp peptides recruit fibroblasts'], ['Substrate only', 'Same precursors, plus MSM'], ['Signal damper', 'Methyl and sulfur donor'], ['Signal blocker', 'Shuts the inflammatory switch']]],
      ['Molecular target', 'Treg cells, chondrocytes, osteoblasts', 'Three cell types, three jobs', [['Chondrocyte GAG synthesis', 'NF-κB in vitro'], ['Fibroblasts and chondrocytes', 'Via Pro-Hyp and Hyp-Gly'], ['Chondrocyte GAG synthesis', ''], ['NF-κB, IL-1β, TNF-α', 'Plus radical scavenging'], ['NF-κB, COX-2, MMP-13', 'The enzymes that chew cartilage']]],
      ['Does the dose reach it', 'Yes for UC-II®', 'Acts in gut immune tissue, not the bloodstream', [['The known weak point', 'Lab effects need 100 to 1000× plasma levels'], ['Yes', 'Pro-Hyp measurable in blood for hours'], ['Same weak point', 'Identical actives'], ['Yes', 'Crosses membranes freely'], ['Only with piperine', 'Gut wall neutralises it first']]],
      ['Oral bioavailability', 'Pre-dissolved', 'Nothing to disintegrate', [['9.4% and 6.1%', 'Sulfate versus hydrochloride'], ['High', 'Di- and tripeptides survive digestion'], ['About 6 to 9%', 'Same salts, in a tablet'], ['Near complete', 'Small polar molecule'], ['About 1%', 'Piperine lifts it roughly 20-fold']]]
    ],
    1: [
      ['Collagen delivered', 'Type II, plus I, V and X', 'The types cartilage is actually built from', [['None', 'Sugars, not protein'], ['Type I and III', 'Skin and tendon types'], ['None', ''], ['None', ''], ['None', '']]],
      ['Immune pathway', 'Oral tolerance', 'Gut immune tissue teaches T cells to stand down', [['None', ''], ['None', 'Hydrolysed, helix destroyed'], ['None', ''], ['Cytokine damping', 'Blunts the signal, no retraining'], ['Cytokine damping', 'Blunts the signal, no retraining']]],
      ['Bone pathway', 'Osteoblast signal + D3', 'BonePep™ peptides, then calcium uptake', [['None', ''], ['Osteoblast stimulation', 'Density data in postmenopausal women'], ['None', ''], ['None', ''], ['None', '']]],
      ['Marker moved in trials', 'CTX-II down 17.2%', 'Cartilage breakdown, inside one week', [['CRP down 23%', 'Systemic, not joint specific'], ['CRP and ESR down', 'Six-month trial'], ['Not shown', ''], ['Homocysteine and MDA down', 'Oxidative stress markers'], ['IL-1β, TNF-α and CRP down', 'Consistent across RCTs']]],
      ['Synovial fluid', 'Supported', 'Hyaluronic acid already inside Ovomet®', [['Supported', 'Chondroitin holds water in the matrix'], ['Indirect', ''], ['Supported', ''], ['Not targeted', ''], ['Not targeted', '']]],
      ['Vitamin D3', '2000 IU', 'Without it, calcium never reaches bone', [['Not included', ''], ['Not included', ''], ['Not included', ''], ['Not included', ''], ['Not included', '']]]
    ],
    2: [
      ['Absorption route', 'Already in solution', 'No disintegration step at all', [['Active transport', 'Chondroitin depolymerised first'], ['Peptide transporters', 'PepT1 carries them intact'], ['Tablet must break down', 'Then the same transport'], ['Passive diffusion', 'Straight through the membrane'], ['Fat dependent', 'Needs a meal to absorb']]],
      ['First-pass loss', 'Low', 'Liquid, taken as is', [['High for chondroitin', 'A 50 to 100 kDa molecule'], ['Low', 'Peptides pass through'], ['High for chondroitin', ''], ['Minimal', ''], ['Severe', 'Glucuronidated in gut wall and liver']]],
      ['Stomach comfort', 'Gentle', 'Nothing large to swallow', [['Bloating for some', ''], ['Well tolerated', ''], ['Bloating for some', ''], ['Loose stool at high dose', ''], ['Reflux for some', '']]],
      ['Shellfish free', 'Yes', 'Egg based, not shellfish', [['Often shellfish', ''], ['Fish or bovine', ''], ['Often shellfish', ''], ['Yes', ''], ['Yes', '']]],
      ['Products for full cover', 'One', 'Five systems in a single sachet', [['Three to four', ''], ['Three to four', ''], ['Two to three', ''], ['Three to four', ''], ['Three to four', '']]]
    ]
  };

  var vsGroupDefs = [[0, 'What it is built to do', [0]], [1, 'Repair &amp; rebuild', [1, 2, 3]], [2, 'Inflammation &amp; delivery', [4, 5, 6]]];
  var vsOrder = [0, 1, 4, 2, 3];

  var ingredientData = [
    ['Ovomet®', 'Spain', 'Eggshell membrane', 'The complete cartilage matrix in one ingredient: type I, V and X collagen, hyaluronic acid, glucosamine and chondroitin, in the ratios your joints already use.', 'unnamed-25-2.webp', '1765907321'],
    ['Lonza’s UC-II®', 'USA', 'Undenatured type II collagen', 'Kept undenatured, so its triple helix survives digestion and teaches the immune system to stop attacking your cartilage.', 'unnamed-23.webp', '1765906879'],
    ['BonePep™', 'Japan', 'Hydrolyzed egg yolk peptides', 'An egg-yolk peptide that rebuilds the bone beneath the cartilage and slows the mineral loss that comes with age.', '@ing-bonepep.webp', ''],
    ['Turmeric', 'High potency', 'Natural inflammation support', 'A high-potency extract that calms inflammation in the joint fluid, clearing the way for the deeper repair work.', 'unnamed-27-2.webp', '1765907368'],
    ['Vitamin D3', 'Essential', 'Calcium absorption', 'Unlocks calcium absorption, so the minerals you take in actually reach and harden bone.', 'unnamed-26-2.webp', '1765907367'],
    ['Kiwi &amp; green apple', 'Flavor', 'Antioxidant &amp; digestion', 'Real fruit for taste, plus actinidin and polyphenols to help the formula break down and absorb.', 'unnamed-29-2.jpg', '1765907626']
  ];

  var scienceData = [
    { dose: '500 mg', origin: 'Spain', claim: 'Knee stiffness improved up to 26.6% by day 60 (RCT, 500 mg/day)',
      sections: [
        ['What it is', 'Whole eggshell membrane, the paper-thin layer just inside the shell, made in Spain by Eggnovo using only water and mechanical force. That keeps the natural matrix intact, carrying collagen, elastin, hyaluronic acid and glucosamine already assembled together. MoveOn uses a 500 mg daily dose.'],
        ['How it works', 'It works on two fronts: it delivers the literal raw materials of cartilage in a matrix your body recognises, and it acts as a signal inside the joint, switching on cartilage-building genes while quieting the enzymes that break cartilage down. In trials it lowered CTX-II, a cartilage-breakdown marker, by 17.2% within the first week.'],
        ['For your joints', 'In controlled trials a single 500 mg dose eased knee osteoarthritis pain and improved stiffness by up to 26.6% by day 60. In active adults it cut exercise-related joint pain within a day and stiffness within five days.'],
        ['Beyond the joint', 'The same collagen, elastin and hyaluronic acid build skin, tendons and ligaments, so it backs connective tissue throughout the body, not only the knee.']
      ],
      features: ['Patented whole eggshell membrane (Ovomet®)', 'Made in Spain with only water and force, no chemicals', 'One ready-made matrix: collagen, elastin, hyaluronic acid, glucosamine', '500 mg clinically studied daily dose', 'Lowers the CTX-II cartilage-breakdown marker'],
      studies: [
        ['RCT · 67 people · 60 days', 'One 500 mg dose a day eased knee osteoarthritis pain (15.9% better than placebo by day 10) and stiffness (up to 26.6% by day 60).', 'Ruff et al., 2009, Clinical Rheumatology. PMID 19340512.'],
        ['RCT · 60 people · 1 week', '500 mg a day lowered the cartilage-breakdown marker CTX-II by 17.2% in the first week and sped recovery from exercise-related joint pain.', 'Ruff et al., 2018, Clinical Interventions in Aging. PMID 29497287.'],
        ['RCT · 150 people · 12 weeks', 'Eggshell membrane significantly improved KOOS pain and daily-life function versus placebo, with benefit appearing within a week.', 'Kiers &amp; Bult, 2021, Journal of Medicinal Food. PMID 32633648.']
      ] },
    { dose: '40 mg', origin: 'USA', claim: '33% better joint scores than glucosamine + chondroitin',
      sections: [
        ['What it is', 'Undenatured type II collagen, a whole collagen protein kept in its original coiled triple-helix shape, the same form found in your own cartilage. Made in the USA by Lonza and standardised to a precise 40 mg daily dose.'],
        ['How it works', 'Because it stays undenatured, a small dose survives digestion and reaches immune tissue in the small intestine. There the intact helix triggers oral tolerance, training regulatory T cells to treat type II collagen as self rather than a threat, which dials down the inflammatory friendly-fire that breaks cartilage down.'],
        ['For your joints', 'By calming that immune attack it eases pain, stiffness and loss of function, and improved how far the knee could comfortably bend. Head to head it beat glucosamine plus chondroitin, cutting joint scores 33% versus 14% and pain 40% versus 15.4%.'],
        ['Beyond the joint', 'Because it retrains immune tolerance in the gut rather than masking symptoms, the benefit starts at the gut-immune interface. Preclinical work showed it preserved gut integrity while reducing inflammatory signalling.']
      ],
      features: ['Patented undenatured type II collagen', 'Triple-helix shape kept intact, matching your own cartilage', 'Clinically studied 40 mg once-daily dose', 'Works through oral tolerance, not brute force', 'Made in the USA by Lonza'],
      studies: [
        ['RCT · 191 people · 180 days', 'At 40 mg a day it lowered total WOMAC joint scores more than both placebo and glucosamine plus chondroitin, with gains in pain, stiffness and function.', 'Lugo et al., 2016, Nutrition Journal. PMID 26822714.'],
        ['RCT · head to head · 90 days', 'UC-II cut WOMAC scores by 33% versus 14% for glucosamine plus chondroitin, and pain by 40% versus 15.4%.', 'Crowley et al., 2009, International Journal of Medical Sciences. PMID 19847319.'],
        ['RCT · 55 people · 120 days', 'In volunteers with knee discomfort on exertion, 40 mg/day improved average knee extension (81.0 vs 73.2 degrees) and extended exercise before discomfort.', 'Lugo et al., 2013, Journal of the International Society of Sports Nutrition. PMID 24153020.']
      ] },
    { dose: '100 mg', origin: 'Japan', claim: '100 mg/day cut bone-breakdown markers in a 6-month human trial',
      sections: [
        ['What it is', 'A peptide made by gently breaking egg-yolk protein into smaller, easy-to-absorb pieces through enzyme hydrolysis. Patented and produced in Japan by Pharma Foods International, effective at a small 100 mg daily dose.'],
        ['How it works', 'Bone is constantly torn down by osteoclasts and rebuilt by osteoblasts. BonePep® tips that balance toward building by activating the Wnt and beta-catenin pathway, telling osteoblasts to multiply, lay down collagen and deposit calcium, while lowering markers of bone resorption.'],
        ['For your joints', 'Your joints rest on a layer of bone beneath the cartilage, and when that bone weakens the whole joint loses support. A denser bone bed under the joint is what lets the cartilage above keep cushioning.'],
        ['Beyond the joint', 'Bone density is a whole-skeleton concern. The same peptide supports hips, spine and frame, with the clearest effect in perimenopausal women when bone loss accelerates.']
      ],
      features: ['Patented hydrolysed egg-yolk peptide', 'Made in Japan by Pharma Foods International', 'Clinically studied 100 mg daily dose', 'Pre-digested peptides for easy absorption', 'Both builds bone and slows breakdown'],
      studies: [
        ['RCT · 65 women · 6 months', 'In perimenopausal women, 100 mg per day significantly lowered markers of bone breakdown, pointing to a bone-preserving effect.', 'Abdou et al., 2014, Food Science &amp; Nutrition. PMID 24936288.'],
        ['Lab study · human osteoblasts', 'Egg-yolk peptide dose-dependently boosted bone-cell growth, alkaline phosphatase, collagen synthesis and calcium deposition.', 'Kim et al., 2014, Molecules. DOI 10.3390/molecules190912909.'],
        ['Preclinical · bone loss model', 'Hydrolysed egg-yolk peptide improved bone mineral density, microstructure and strength through the Wnt/beta-catenin pathway.', 'Chen et al., 2024, Scientific Reports. PMID 38702443.']
      ] },
    { dose: '500 mg', origin: 'Standardised extract', claim: 'As effective as ibuprofen for knee pain, with fewer stomach side effects (367-patient RCT)',
      sections: [
        ['What it is', 'Turmeric root concentrated into a standardised curcuminoid extract and dosed at 500 mg, so every batch carries the same real amount instead of whatever a pinch of spice happens to contain.'],
        ['How it works', 'Curcumin blocks COX-2, the same enzyme ibuprofen acts on, and quiets NF-kB, the master switch that turns on inflammatory genes. That lowers messengers like TNF-alpha and the systemic marker CRP at the source rather than masking the result.'],
        ['For your joints', 'That quiet, year-after-year inflammation is what slowly wears cartilage down. In head-to-head trials standardised curcumin matched ibuprofen and paracetamol on knee pain, stiffness and function, and people used less rescue medication.'],
        ['Beyond the joint', 'Trials show it lowers circulating CRP and TNF-alpha, two markers tied to whole-body inflammatory load, supporting heart and metabolic health as you age.']
      ],
      features: ['Standardised curcumin extract, consistent dose every batch', '500 mg daily', 'Blocks COX-2, the same target as ibuprofen', 'Lowers CRP and TNF-alpha', 'Gentler on the stomach than NSAIDs in trials'],
      studies: [
        ['RCT · 367 patients · 4 weeks', 'Curcuma domestica extract worked as well as ibuprofen on total WOMAC score, pain and function, with fewer stomach side effects.', 'Kuptniratsaikul et al., 2014, Clinical Interventions in Aging. PMID 24672232.'],
        ['Meta-analysis · 15 RCTs · 1,670 people', 'Curcuminoids beat placebo on pain and on WOMAC total, pain and function, and were non-inferior to NSAIDs without raising adverse events.', 'Feng et al., 2022, BMC Complementary Medicine and Therapies. PMID 36261810.'],
        ['RCT · 193 people · 6 weeks', 'Bioavailable turmeric extract was equivalent to paracetamol across all WOMAC domains while reducing CRP by 37% and TNF-alpha by 75%.', 'Singhal et al., 2021, Trials. PMID 33516238.']
      ] },
    { dose: 'Foundation dose', origin: 'Cholecalciferol', claim: '700 to 800 IU/day cut hip-fracture risk about 26% (400 IU did nothing)',
      sections: [
        ['What it is', 'Cholecalciferol, the same form of vitamin D your skin makes in sunlight. A fat-soluble compound the body treats less like a vitamin and more like a hormone precursor, so supply does not depend on sun, season or skin tone.'],
        ['How it works', 'Your liver converts D3 to 25-hydroxyvitamin D, then your kidneys to the active hormone calcitriol, which switches on the gut proteins that pull calcium out of food and into your blood. It also signals the parathyroid glands to stop leaching calcium back out of bone.'],
        ['For your joints', 'Raising vitamin D status from low-normal to about 35 ng/mL increased calcium absorption efficiency by roughly 45 to 65%, so low D directly caps how much calcium reaches bone. With calcium, 800 IU held femoral neck bone density stable while it fell about 2.4% a year on placebo.'],
        ['Beyond the joint', 'Nearly every tissue carries vitamin D receptors. It supports muscle function and balance, reducing the risk of falling in older adults by about 22%, and plays a recognised role in normal immune function.']
      ],
      features: ['The same D3 your skin makes in sunlight', 'Dosed in the clinically meaningful 700 to 800 IU range', 'Unlocks calcium absorption so it reaches bone', 'Supports muscle, balance and immune function', 'Lowers parathyroid signalling that leaches calcium from bone'],
      studies: [
        ['Human crossover trial', 'Raising vitamin D status from about 20 to 35 ng/mL increased calcium absorption efficiency by roughly 45 to 65%.', 'Heaney et al., 2003, Journal of the American College of Nutrition. PMID 12672710.'],
        ['Meta-analysis · fracture RCTs', 'In older adults, 700 to 800 IU per day lowered hip-fracture risk by about 26%, while 400 IU/day produced no significant benefit.', 'Bischoff-Ferrari et al., 2005, JAMA. PMID 15886381.'],
        ['RCT · 583 women · 2 years', 'Calcium plus 800 IU vitamin D3 daily kept femoral neck bone density stable while it declined about 2.4% per year on placebo.', 'Chapuy et al., 2002, Osteoporosis International. PMID 11991447.']
      ] },
    { dose: 'Natural flavour', origin: 'Kiwi &amp; green apple', claim: 'Actinidin and polyphenols, so the formula tastes good and absorbs well',
      sections: [
        ['What it is', 'Real kiwi and green apple, the flavour base of the sachet. Kiwi naturally carries actinidin, a protein-digesting enzyme, and both fruits bring polyphenols.'],
        ['How it works', 'Actinidin helps break down the peptides and collagen in the formula so they are easier to absorb, while the polyphenols add antioxidant cover against everyday oxidative stress.'],
        ['Why it matters', 'A daily habit only works if you look forward to it. Five seconds, no water, and a taste that makes the routine easy to keep.']
      ],
      features: ['Real fruit, not artificial sweetener', 'Actinidin, a natural digestive enzyme from kiwi', 'Polyphenol antioxidants', 'Makes a daily habit easy to keep'],
      studies: [] }
  ];

  var faqData = [
    ['Where do you ship to?', 'MoveOn currently ships within the United States only, and shipping is 100% free. Orders are dispatched within 24 hours and usually arrive within 3 to 5 business days.'],
    ['What does MoveOn taste like?', 'MoveOn has a refreshing kiwi and apple taste, sweet and slightly tangy. It is designed to be delicious and easy to swallow, so you won’t dread taking it every day.'],
    ['How do I drink MoveOn? Do I need to mix it with water?', 'MoveOn comes in a ready-to-drink liquid sachet. You don’t need to mix it with water or shake it. Just tear open the sachet and drink it directly.'],
    ['How long will it take before I feel less pain?', 'Everyone heals differently depending on how long they have had the issue. While some users feel lighter and more flexible within the first 7 to 14 days, we recommend taking it consistently for at least 30 to 60 days.'],
    ['Is MoveOn a medicine?', 'No. MoveOn is classified as a functional food, not a pharmaceutical drug. It uses high-quality food ingredients (like turmeric and eggshell membrane) to support health naturally, so it is generally safer for long-term use.'],
    ['I already had knee surgery. Is it safe during recovery?', 'Yes, it is highly recommended. Surgery puts stress on the body, and MoveOn provides the specific nutrients (collagen, elastin, hyaluronic acid) your body needs to rebuild tissue and recover faster.'],
    ['Do I need to keep drinking this forever?', 'For the best results we suggest completing a full cycle, usually around 3 boxes, to allow your joints to repair. Once you feel flexible and pain-free you can switch to every other day for maintenance.'],
    ['I have pain in my lower back, fingers and hips, not just my knees. Will this help?', 'Yes. Because you drink MoveOn, the nutrients are absorbed into your bloodstream and circulate to all your joints. The ingredients work to reduce inflammation and repair cartilage wherever your body needs it most.'],
    ['Who is MoveOn suitable for?', 'Anyone experiencing joint discomfort or limited mobility: pain when climbing stairs or standing up, aches from standing too long, stiffness or frozen shoulder, stiff fingers or weak grip, and clicking or popping sounds when you move.'],
    ['Does MoveOn contain steroids or painkillers?', 'Absolutely not. MoveOn is 100% drug-free and steroid-free. It uses natural, clinical-grade food ingredients to help the body repair itself, and is safe for long-term use.'],
    ['I am allergic to seafood or shellfish. Can I still take this?', 'Yes. Unlike traditional glucosamine which is often made from shrimp or crab shells, MoveOn is made from eggshell membrane (Ovomet®) and chicken cartilage (UC-II®). It is safe for those with shellfish allergies.'],
    ['I am younger and play sports, is this only for older people?', 'Definitely not. Sports wear down cartilage faster than normal. Taking MoveOn as a younger person helps maintain your joint fluid and cartilage thickness, preventing injuries.'],
    ['I have high blood pressure and diabetes. Is it safe for me?', 'Yes, MoveOn is generally safe alongside most medications. It is low in sugar and formulated to be diabetic-friendly. If you are on strong blood thinners, show the ingredients list to your doctor first.']
  ];

  var statData = [90, 88, 82, 78];

  /* ==========================================================================
     STATE
     ========================================================================== */
  var st = {
    img: 0, bundle: 1, plan: 'sub', info: -1, faq: -1,
    revCount: 0, revMobile: false, sticky: false, statsRan: false,
    dr: 0, rot: 0, vsOpenIdx: null, sheetIng: null,
    menuOpen: false, cartOpen: false, cart: null
  };

  /* ==========================================================================
     STATIC RENDERS (run once)
     ========================================================================== */

  function renderPress() {
    var el = $('[data-press]'); if (!el) return;
    var loop = press.concat(press, press, press);
    el.innerHTML = loop.map(function (p) {
      return '<img src="' + cdn(p[0], p[1], 200) + '" alt="' + esc(p[2]) + '" width="112" height="28" decoding="async" ' +
        'style="flex: none; height: 28px; width: 112px; margin: 0 22px; object-fit: contain; opacity: .72;">';
    }).join('');
  }

  function renderExperts() {
    var el = $('[data-experts]'); if (!el) return;
    var one = expertData.map(function (e, i) {
      return { name: e[0], role: e[1], avatar: cdn(e[2], e[3], 260), video: asset('expert-' + (i + 1) + '.mp4') };
    });
    el.innerHTML = one.concat(one, one, one).map(function (e) {
      return '<div style="flex: 0 0 236px; display: flex; flex-direction: column; background: #ffffff; border-radius: 18px; overflow: hidden; box-shadow: 0 10px 24px rgba(45,76,38,.08);">' +
        /* data-src + no autoplay: `autoplay` overrides preload="none" and makes the
           browser fetch every clip on load. These are ~5 MB each, so that was 23 MB
           before a visitor had scrolled anywhere near them. tryPlay() attaches the
           source when the card actually reaches the viewport. */
        '<video data-muted-video data-src="' + e.video + '" poster="' + e.avatar + '" muted loop playsinline preload="none" disablepictureinpicture disableremoteplayback controlslist="nodownload noplaybackrate noremoteplayback" style="width: 100%; aspect-ratio: 9 / 16; object-fit: cover; display: block; background: #e9efe6; pointer-events: none;"></video>' +
        '<div style="padding: 14px 16px 16px; display: flex; flex-direction: column; gap: 4px;">' +
        '<span style="display: flex; align-items: center; gap: 6px; font-size: 15px; font-weight: 700; color: #20271c; line-height: 1.2;">' + e.name +
        '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" style="flex: none;"><circle cx="12" cy="12" r="11" fill="#4e7d3f"></circle><path d="M17 9l-6 6-3.4-3.4" fill="none" stroke="#fff" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>' +
        '<span style="font-size: 14px; line-height: 1.35; color: #646458; text-wrap: pretty;">' + e.role + '</span>' +
        '</div></div>';
    }).join('');
    primeVideos(el);
  }

  function renderUgc() {
    var src = function (u) { return typeof u === 'string' ? u : cdn(u[0], u[1], 500); };
    var tall = 'width: clamp(170px, 21vw, 240px); height: clamp(230px, 27vw, 320px); object-fit: cover; border-radius: 24px; display: block; background: #ffffff;';
    var wide = 'width: clamp(170px, 21vw, 240px); height: clamp(180px, 21vw, 240px); object-fit: cover; border-radius: 24px; display: block; background: #ffffff;';
    var a = $('[data-ugc]'), b = $('[data-ugc-alt]');
    if (a) a.innerHTML = ugcFiles.concat(ugcFiles).map(function (u) { return '<img src="' + src(u) + '" alt="Customer photo" decoding="async" style="' + tall + '">'; }).join('');
    var rev = ugcFiles.slice().reverse();
    if (b) b.innerHTML = rev.concat(rev).map(function (u) { return '<img src="' + src(u) + '" alt="Customer photo" decoding="async" style="' + wide + '">'; }).join('');
  }

  function renderIngredients() {
    var el = $('[data-ing-rail]'); if (!el) return;
    el.innerHTML = ingredientData.map(function (d, i) {
      return '<div class="mo-ingcard" style="flex: 0 0 clamp(258px, 76vw, 340px); scroll-snap-align: start; display: flex; flex-direction: column; border-radius: 24px; overflow: hidden; background: #e9efe6;">' +
        '<img class="mo-ingimg" src="' + cdn(d[4], d[5], 220) + '" alt="' + d[0] + '" loading="lazy" style="width: 100%; height: clamp(300px, 34vw, 400px); object-fit: cover; display: block;">' +
        '<div class="mo-ingbody" style="padding: 24px; display: flex; flex-direction: column; gap: 10px; flex: 1;">' +
        '<div class="mo-ingtop" style="display: flex; flex-wrap: wrap; align-items: baseline; gap: 8px;">' +
        '<h3 style="margin: 0; font-size: 22px; font-weight: 800; color: #20271c;">' + d[0] + '</h3>' +
        '<span class="mo-ingorigin" style="font-size: 13px; font-weight: 600; letter-spacing: .04em; color: #646458;">' + d[1] + '</span></div>' +
        '<p class="mo-ingsub" style="margin: 0; font-size: 13px; font-weight: 600; letter-spacing: .16em; text-transform: uppercase; color: #80412b;">' + d[2] + '</p>' +
        '<p class="mo-ingdesc" style="margin: 0; font-size: 17px; color: #20271c; text-wrap: pretty;">' + d[3] + '</p>' +
        '<button type="button" data-ing-open="' + i + '" style="margin-top: auto; align-self: flex-start; padding: 0; background: none; border: 0; cursor: pointer; font-family: inherit; font-size: 13px; font-weight: 700; color: #2d4c26; text-decoration: underline; text-underline-offset: 3px;">Read the full science</button>' +
        '</div></div>';
    }).join('');
  }

  function renderFaq() {
    var el = $('[data-faq]'); if (!el) return;
    el.innerHTML = faqData.map(function (f, i) {
      return '<div style="border-bottom: 1px solid rgba(45,76,38,.16);">' +
        '<button type="button" data-faq-toggle="' + i + '" aria-expanded="false" style="width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 20px 2px; background: none; border: 0; cursor: pointer; text-align: left; font-family: inherit; font-size: 17px; font-weight: 700; color: #2d4c26;">' +
        f[0] + '<span data-sign style="flex: none; font-size: 20px; color: #80412b;">+</span></button>' +
        '<p class="mo-faq-body" style="margin: 0; padding: 0 2px 24px; font-size: 17px; color: #20271c; text-wrap: pretty;">' + f[1] + '</p>' +
        '</div>';
    }).join('');
  }

  /* ==========================================================================
     COMPARISON TABLE — style strings ported verbatim from renderVals()
     ========================================================================== */
  function renderVs() {
    var grid = $('[data-vs-grid]'); if (!grid) return;
    var rv = vsOrder.map(function (i) { return rivals[i]; });
    var out = [];

    /* corner + header row */
    out.push('<div style="position: sticky; left: 0; z-index: 4; background: #fbf7f3; border-bottom: 1px solid #e6ded4; border-top-left-radius: 18px;"></div>');
    var heads = [{
      name: 'MoveOn™', lead: true,
      style: 'position: sticky; left: 126px; z-index: 3; padding: 12px 14px; background: linear-gradient(135deg, #B85727 0%, #9A4720 100%); border-bottom: 1px solid #9A4720; display: flex; flex-direction: column; gap: 4px; align-items: flex-start; justify-content: center; box-shadow: 6px 0 10px -9px rgba(45,76,38,.5);',
      nameStyle: 'font-size: 16px; font-weight: 800; color: #ffffff;'
    }].concat(rv.map(function (r) {
      return {
        name: r.name, lead: false,
        style: 'padding: 12px 14px; background: linear-gradient(135deg, #F6D3B6 0%, #EFC1A0 100%); border-left: 1px solid rgba(154,71,32,.16); border-bottom: 1px solid #e6b391; display: flex; flex-direction: column; gap: 4px; align-items: flex-start; justify-content: flex-end;',
        nameStyle: 'font-size: 14px; font-weight: 700; color: #6d3520;'
      };
    }));
    heads.forEach(function (h, i) {
      var style = h.style + (i === heads.length - 1 ? ' border-top-right-radius: 18px;' : '');
      out.push('<div style="' + style + '">' +
        (h.lead ? '<span style="padding: 2px 8px; border-radius: 999px; background: rgba(255,255,255,.16); border: 1px solid rgba(255,255,255,.42); color: #ffffff; font-size: 10px; font-weight: 700; letter-spacing: .02em; line-height: 1.25; white-space: nowrap;">Gold standard</span>' : '') +
        '<span style="' + h.nameStyle + '">' + h.name + '</span></div>');
    });

    /* coverage row */
    out.push('<div style="position: sticky; left: 0; z-index: 3; background: #ffffff; padding: 10px 14px; font-size: 14px; font-weight: 700; color: #20271c; display: flex; align-items: center; border-bottom: 1px solid #efe7e0;">Joint systems covered</div>');
    var cov = [{ covered: 5, text: '5 of 5 systems', lead: true }].concat(rv.map(function (r) {
      return { covered: r.covered, text: r.coverText, lead: false };
    }));
    cov.forEach(function (c) {
      var style = 'padding: 10px 14px; display: flex; align-items: center; flex-wrap: wrap; gap: 5px 8px; border-bottom: 1px solid #efe7e0;' +
        (c.lead ? ' position: sticky; left: 126px; z-index: 2; background: #dfe9d7; border-bottom-color: #cddcc3; box-shadow: 8px 0 16px -10px rgba(32,39,28,.45);' : ' border-left: 1px solid #f1eae4;');
      var dots = [0, 1, 2, 3, 4].map(function (i) {
        var bg = i < c.covered ? (c.lead ? '#2d4c26' : '#cf9a72') : (c.lead ? 'rgba(45,76,38,.20)' : '#f0e3d8');
        return '<span style="width: 11px; height: 5px; border-radius: 999px; background: ' + bg + ';"></span>';
      }).join('');
      out.push('<div style="' + style + '"><div style="display: flex; gap: 3px;">' + dots + '</div>' +
        '<span style="font-size: 13px; font-weight: 700; color: ' + (c.lead ? '#2d4c26' : '#80412b') + ';">' + c.text + '</span></div>');
    });

    /* groups */
    var rule = ' border-bottom: 1px solid #efe7e0;';
    var cellBase = 'padding: 9px 14px; display: flex; flex-direction: column; justify-content: center; gap: 2px;';
    vsGroupDefs.forEach(function (g) {
      var gi = g[0], isOpen = st.vsOpenIdx === gi, extra = compExtra[gi] || [];
      var rowSet = g[2].map(function (ri) { return compData[ri]; }).concat(isOpen ? extra : []);
      var hint = extra.length ? (isOpen ? 'See less' : 'See more') : '';

      out.push('<div data-vs-band="' + gi + '" role="button" tabindex="0" aria-expanded="' + isOpen + '" style="grid-column: 1 / -1; padding: 8px 14px; background: #2d4c26; border-bottom: 1px solid #2d4c26; border-top: 1px solid #2d4c26; display: flex; align-items: center; justify-content: space-between; gap: 12px; cursor: pointer; user-select: none; font-size: 13px; font-weight: 700; color: #ffffff;">' +
        '<span style="position: sticky; left: 14px; display: flex; align-items: center; gap: 8px; width: max-content;">' +
        '<span>' + g[1] + '</span>' +
        '<span style="font-size: 12px; font-weight: 600; color: #ffffff; opacity: .8;">' + hint + '</span>' +
        '<span style="display: flex; color: #ffffff; opacity: .8; transition: transform .18s ease; transform: rotate(' + (isOpen ? '180deg' : '0deg') + ');">' +
        '<svg viewBox="0 0 16 16" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6l5 5 5-5"></path></svg>' +
        '</span></span></div>');

      rowSet.forEach(function (row, k) {
        var last = gi === 2 && k === rowSet.length - 1;
        out.push('<div style="position: sticky; left: 0; z-index: 3; background: #ffffff; padding: 9px 14px; font-size: 14px; font-weight: 600; color: #20271c; display: flex; align-items: center;' + (last ? ' border-bottom-left-radius: 18px;' : rule) + '">' + row[0] + '</div>');

        /* MoveOn cell */
        out.push('<div style="' + cellBase + ' position: sticky; left: 126px; z-index: 2; background: #dfe9d7; box-shadow: 8px 0 16px -10px rgba(32,39,28,.45);' + (last ? '' : ' border-bottom: 1px solid #cddcc3;') + '">' +
          '<span style="font-size: 14px; font-weight: 700; color: #2d4c26;"><span style="color: #B85727;">✓ </span>' + row[1] + '</span>' +
          (row[2] ? '<span style="font-size: 12px; line-height: 1.35; color: #55705f;">' + row[2] + '</span>' : '') + '</div>');

        /* rival cells */
        rv.forEach(function (r, ci) {
          var v = row[3][vsOrder[ci]];
          var none = v[0] === 'None' || v[0] === 'Not included' || v[0] === 'Not targeted';
          var style = cellBase + (last ? '' : rule) + ' border-left: 1px solid #f1eae4;' + (last && ci === rv.length - 1 ? ' border-bottom-right-radius: 18px;' : '');
          out.push('<div style="' + style + '">' +
            '<span style="font-size: 14px; font-weight: ' + (none ? '500' : '600') + '; color: ' + (none ? '#a3a39b' : '#20271c') + ';">' + v[0] + '</span>' +
            (v[1] ? '<span style="font-size: 12px; line-height: 1.35; color: #6d6d64;">' + v[1] + '</span>' : '') + '</div>');
        });
      });
    });

    grid.innerHTML = out.join('');
  }

  /* ==========================================================================
     REVIEW WALL
     ========================================================================== */
  function revBase() { return st.revMobile ? 3 : 6; }
  function revCount() { return Math.min(st.revCount || revBase(), reviewData.length); }

  function renderReviews() {
    var grid = $('[data-rev-grid]'); if (!grid) return;
    grid.innerHTML = reviewData.slice(0, revCount()).map(function (r) {
      var stars = '★★★★★'.slice(0, r[0]) + '☆☆☆☆☆'.slice(0, 5 - r[0]);
      return '<div style="display: flex; flex-direction: column; gap: 10px; padding: 24px; border-radius: 24px; background: #ffffff; border: 1px solid #e3ded1;">' +
        '<span style="color: #B85727; letter-spacing: .12em; font-size: 15px;">' + stars + '</span>' +
        '<p style="margin: 0; font-size: 17px; font-weight: 800; color: #20271c;">' + r[1] + '</p>' +
        '<p style="margin: 0; font-size: 17px; color: #20271c; text-wrap: pretty;">' + r[2] + '</p>' +
        '<p style="margin: auto 0 0; padding-top: 8px; display: flex; align-items: center; gap: 7px; font-size: 15px; color: #646458;">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" style="flex: 0 0 auto;"><path d="M12 3.1Q15.46 1.35 17.23 4.8Q21.06 5.42 20.46 9.25Q23.2 12 20.46 14.75Q21.06 18.58 17.23 19.2Q15.46 22.65 12 20.9Q8.54 22.65 6.77 19.2Q2.94 18.58 3.54 14.75Q0.8 12 3.54 9.25Q2.94 5.42 6.77 4.8Q8.54 1.35 12 3.1Z" fill="#1D5FA8"></path><path d="M8.4 12.2l2.4 2.4 4.8-5" fill="none" stroke="#ffffff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
        '<span style="color: #1D5FA8; font-weight: 600;">Verified customer</span><span>· ' + r[3] + '</span></p></div>';
    }).join('');

    $('[data-rev-wrap]').classList.toggle('mo-rev-more', revCount() < reviewData.length);
    $('[data-rev-toggle]').textContent = revCount() >= reviewData.length ? 'Show fewer reviews' : 'Read more reviews';
  }

  /* ==========================================================================
     INGREDIENT SCIENCE SHEET
     ========================================================================== */
  function openSheet(i) {
    var d = ingredientData[i], sc = scienceData[i];
    if (!d || !sc) return;
    var wasOpen = st.sheetIng !== null;
    st.sheetIng = i;
    $('[data-sheet-img]').src = cdn(d[4], d[5], 900);
    $('[data-sheet-body]').innerHTML =
      '<div style="display: flex; flex-direction: column; gap: 10px;">' +
      '<h3 style="margin: 0; font-size: clamp(24px, 3.6vw, 30px); line-height: 1.1; letter-spacing: -.01em; font-weight: 800; color: #2d4c26;">' + d[0] + '</h3>' +
      '<p style="margin: 0; font-size: 13px; font-weight: 600; letter-spacing: .16em; text-transform: uppercase; color: #80412b;">' + d[2] + '</p>' +
      '<div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px;">' +
      '<span style="padding: 5px 14px; border-radius: 999px; background: #2d4c26; color: #ffffff; font-size: 13px; font-weight: 700;">' + sc.dose + '</span>' +
      '<span style="padding: 5px 14px; border-radius: 999px; background: #e9efe6; color: #2d4c26; font-size: 13px; font-weight: 600;">' + sc.origin + '</span></div>' +
      '<p style="margin: 4px 0 0; padding: 14px 16px; border-radius: 14px; background: #f4f6f1; font-size: 15px; font-weight: 600; color: #2d4c26; text-wrap: pretty;">' + sc.claim + '</p></div>' +
      sc.sections.map(function (s) {
        return '<div style="display: flex; flex-direction: column; gap: 6px;">' +
          '<h4 style="margin: 0; font-size: 17px; font-weight: 800; color: #2d4c26;">' + s[0] + '</h4>' +
          '<p style="margin: 0; font-size: 17px; line-height: 1.5; color: #20271c; text-wrap: pretty;">' + s[1] + '</p></div>';
      }).join('') +
      '<div style="display: flex; flex-direction: column; gap: 10px; padding-top: 4px; border-top: 1px solid rgba(45,76,38,.14);">' +
      '<h4 style="margin: 6px 0 0; font-size: 17px; font-weight: 800; color: #20271c;">Features</h4>' +
      '<ul style="list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px;">' +
      sc.features.map(function (f) {
        return '<li style="display: flex; gap: 10px; align-items: baseline; font-size: 15px; color: #20271c;"><span style="color: #2d4c26; font-weight: 800;">✓</span><span>' + f + '</span></li>';
      }).join('') + '</ul></div>' +
      (sc.studies.length
        ? '<div style="display: flex; flex-direction: column; gap: 12px; padding-top: 4px; border-top: 1px solid rgba(45,76,38,.14);">' +
          '<h4 style="margin: 6px 0 0; font-size: 17px; font-weight: 800; color: #20271c;">The clinical evidence</h4>' +
          sc.studies.map(function (s) {
            /* comp had this meta label at #dfe9d7 on #f8f8f7 (invisible); using the
               same rust the other uppercase meta labels on the page use */
            return '<div style="display: flex; flex-direction: column; gap: 5px; padding: 16px; border-radius: 14px; background: #f8f8f7;">' +
              '<span style="font-size: 13px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: #80412b;">' + s[0] + '</span>' +
              '<p style="margin: 0; font-size: 15px; line-height: 1.5; color: #20271c; text-wrap: pretty;">' + s[1] + '</p>' +
              '<span style="font-size: 13px; color: #646458;">' + s[2] + '</span></div>';
          }).join('') + '</div>'
        : '');
    $('[data-sheet-card]').scrollTop = 0;
    $('[data-sheet]').classList.add('is-open');
    if (!wasOpen) lockScroll(true);
  }

  function closeSheet() {
    if (st.sheetIng === null) return;
    st.sheetIng = null;
    $('[data-sheet]').classList.remove('is-open');
    lockScroll(false);
  }

  /* ==========================================================================
     PRICING — the comp's renderVals() money block
     ========================================================================== */
  function syncPrices() {
    var sub = st.plan === 'sub';
    var b = bundleData[st.bundle];
    var total = sub ? b.sub_price : b.price;

    $$('[data-bundle]').forEach(function (row) {
      var i = +row.getAttribute('data-bundle'), d = bundleData[i];
      var now = sub ? d.sub_price : d.price;
      row.classList.toggle('is-on', i === st.bundle);
      $('input', row).checked = i === st.bundle;
      var _sv = $('[data-save]', row);
      _sv.textContent = 'Save ' + money(d.save) + ' (' + d.extra + '%)';
      _sv.style.display = sub ? '' : 'none';
      $('[data-price]', row).textContent = money(now);
      var s = $('[data-strike]', row);
      s.textContent = money(d.price);
      s.classList.toggle('is-hidden', !sub);
    });

    var subRow = $('[data-plan="sub"]'), onceRow = $('[data-plan="once"]');
    subRow.classList.toggle('is-on', sub);
    onceRow.classList.toggle('is-on', !sub);
    $('.mo-dot', subRow).classList.toggle('is-on', sub);
    $('.mo-dot', onceRow).classList.toggle('is-on', !sub);
    $('input', subRow).checked = sub;
    $('input', onceRow).checked = !sub;
    $('[data-sub-frame]').classList.toggle('mo-neon', sub);
    $('[data-sub-perks]').style.display = sub ? 'flex' : 'none';

    $('[data-sub-save]').textContent = 'Extra ' + b.extra + '% off';
    $('[data-sub-extra]').textContent = 'Extra ' + b.extra + '% off (save ' + money(b.save) + ')';
    $('[data-sub-perbox]').textContent = money(b.sub_price / (st.bundle + 1)) + ' each box';
    $('[data-sub-price]').textContent = money(b.sub_price);
    $('[data-once-price]').textContent = money(b.price);
    $('[data-cta-price]').textContent = money(total);

    /* desktop reads "MoveOn · 2 Boxes subscription"; the phone layout drops the
       brand prefix and the suffix and puts the plan on its own short line */
    $('[data-sticky-bundle]').textContent = b.title;
    $('[data-sticky-suffix]').textContent = sub ? ' subscription' : '';
    $('[data-sticky-plan]').textContent = sub ? 'Monthly subscription' : 'One-time purchase';
    $('[data-sticky-price]').textContent = '$' + total;
    syncAppstle();
    $('[data-sticky-total]').textContent = sub
      ? '$' + total + ' today, then $' + b.sub_price + ' monthly'
      : '$' + total + ' one-time';
  }

  /* ==========================================================================
     CART
     ========================================================================== */
  /* Drawer is a mock: it shows what the shopper picked. The real Shopify cart is
     only built at Checkout by goToCheckout(). */
  var SACHETS = [16, 32, 48];

  function syncCart() {
    var c = st.cart;
    var n = $('[data-cart-count]'); if (n) n.textContent = c ? c.qty : 0;
    $('[data-cart-filled]').style.display = c ? 'flex' : 'none';
    $('[data-cart-foot]').style.display = c ? 'flex' : 'none';
    $('[data-cart-empty]').style.display = c ? 'none' : 'block';
    if (!c) return;

    var sub = c.plan === 'sub';
    var d = bundleData[c.bundle];
    $('[data-cart-thumb]').src = c.img;
    $('[data-cart-title]').textContent = d.title;
    $('[data-cart-servings]').textContent = SACHETS[c.bundle] + ' sachets \u00b7 25 ml each';
    $('[data-cart-plan]').textContent = sub
      ? 'Subscribe & Save \u00b7 pause or cancel anytime'
      : 'One-time purchase';

    /* struck price is the one-time price, shown only when subscribing */
    var was = $('[data-cart-was]');
    was.textContent = money(d.price);
    was.classList.toggle('is-hidden', !sub);

    var q = $('[data-cart-qty]'); if (q) q.textContent = c.qty;
    was.textContent = money(d.price * c.qty);
    $('[data-cart-subtotal]').textContent = money(c.unit * c.qty);
    $('[data-cart-total]').textContent = money(c.unit * c.qty);
  }

  function addToCart() {
    var sub = st.plan === 'sub';
    var b = bundleData[st.bundle];
    var item = {
      bundle: st.bundle,
      plan: st.plan,
      title: b.title,
      img: gallery[0],
      unit: sub ? b.sub_price : b.price,
      qty: 1
    };
    /* Repeat add of the same selection increments; the object is mutated in
       place so no field (bundle, plan, unit) can be dropped by a rebuild —
       dropping `bundle` here is what crashed syncCart on every second add. */
    if (st.cart && st.cart.bundle === item.bundle && st.cart.plan === item.plan) {
      st.cart.qty += 1;
    } else {
      st.cart = item;
    }
    syncCart();
    setCart(true);
  }

  /* ==========================================================================
     OVERLAYS
     ========================================================================== */
  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.body.style.overflow = scrollLocks ? 'hidden' : '';
  }
  function setMenu(on) {
    var layer = $('[data-menu-layer]');
    if (!layer || on === st.menuOpen) return;   /* theme owns the nav here */
    st.menuOpen = on;
    layer.classList.toggle('is-open', on);
    var t = $('[data-menu-open]');
    if (t) t.setAttribute('aria-expanded', String(on));
    lockScroll(on);
  }
  function setCart(on) {
    if (on === st.cartOpen) return;
    st.cartOpen = on;
    $('[data-cart-layer]').classList.toggle('is-open', on);
    lockScroll(on);
  }

  /* ==========================================================================
     CAROUSELS
     ========================================================================== */
  function setSlide(i) {
    st.img = (i + gallery.length) % gallery.length;
    $('[data-gallery-main]').src = gallery[st.img];
    $$('[data-gallery-thumbs] .mo-thumb').forEach(function (t, k) { t.classList.toggle('is-on', k === st.img); });
  }

  var drTimer, rotTimer;
  function setDr(i) {
    st.dr = i;
    $$('[data-dr-stage] .mo-drslide').forEach(function (s, k) {
      s.classList.toggle('is-on', k === st.dr);
      s.classList.toggle('is-off', k !== st.dr);
    });
  }
  function startDrTimer() {
    clearInterval(drTimer);
    drTimer = setInterval(function () { setDr((st.dr + 1) % 2); }, 9000);
  }
  function setRot(i) {
    st.rot = i;
    $$('[data-rot-stage] .mo-rotitem').forEach(function (r, k) { r.classList.toggle('is-on', k === st.rot); });
    $$('[data-rot-dots] .mo-rotdot').forEach(function (d, k) { d.classList.toggle('is-on', k === st.rot); });
  }
  function startRotTimer() {
    clearInterval(rotTimer);
    rotTimer = setInterval(function () { setRot((st.rot + 1) % 3); }, 5000);
  }

  /* ==========================================================================
     TIMELINE RAIL (mobile) + STICKY BAR + STATS COUNT-UP
     ========================================================================== */
  var tlGrid, tlLine, tlFill, statsEl;

  function measureTl() {
    if (!tlGrid || !tlLine) return;
    var rails = tlGrid.querySelectorAll('.mo-tlrail');
    if (rails.length < 2 || !window.matchMedia('(max-width: 899px)').matches) { tlLine.style.height = '0px'; return; }
    var gr = tlGrid.getBoundingClientRect();
    var a = rails[0].getBoundingClientRect();
    var li = rails[rails.length - 1].parentElement.getBoundingClientRect();
    var top = a.top - gr.top + 10, bottom = li.bottom - gr.top - 18;
    tlLine.style.top = top + 'px';
    tlLine.style.height = Math.max(0, bottom - top) + 'px';
  }

  function updateTlFill() {
    if (!tlLine || !tlFill) return;
    var r = tlLine.getBoundingClientRect();
    if (!r.height) { tlFill.style.height = '0%'; return; }
    var p = (window.innerHeight * 0.58 - r.top) / r.height;
    tlFill.style.height = Math.max(0, Math.min(1, p)) * 100 + '%';
  }

  function runStatsCountUp() {
    if (st.statsRan) return;
    st.statsRan = true;
    var cells = $$('[data-stat]');
    var start = performance.now();
    (function tick(now) {
      var p = Math.min(1, (now - start) / 1200);
      var e = 1 - Math.pow(1 - p, 3);
      cells.forEach(function (c, i) { c.textContent = Math.round(statData[i] * e) + '%'; });
      if (p < 1) requestAnimationFrame(tick);
    })(start);
  }

  function observeStats() {
    if (!statsEl || st.statsRan) return;
    var r = statsEl.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) { runStatsCountUp(); return; }
    new IntersectionObserver(function (entries, io) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); runStatsCountUp(); }
    }, { threshold: 0.25 }).observe(statsEl);
  }

  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var co = document.getElementById('checkout');
    var atCheckout = co ? co.getBoundingClientRect().top < window.innerHeight - 80 : false;
    var on = y > 900 && !atCheckout;
    if (on !== st.sticky) {
      st.sticky = on;
      $('[data-sticky]').classList.toggle('is-open', on);
    }
    updateTlFill();
  }

  /* ==========================================================================
     VIDEO — the comp force-mutes and kicks off playback
     ========================================================================== */
  /* Two-tier video management, tuned for iOS. Safari caps concurrently playing
     videos at roughly four and silently EVICTS the rest — evicted cards render
     blank (the green placeholder Brandon photographed on his iPhone). So:
       - LOAD tier (wide margin): attach src early so every marquee card has a
         decoded first frame before it scrolls into view — no blank on wrap.
       - PLAY tier (tight margin): only clips actually near the viewport play;
         everything else pauses on its current frame, which keeps iOS under its
         decoder budget. A paused card shows its frame, never a blank. */
  function attachSrc(el) {
    var pending = el.getAttribute('data-src');
    if (pending) {
      el.removeAttribute('data-src');
      el.src = pending;
      el.load();
    }
  }

  function tryPlay(el) {
    el.muted = true; el.defaultMuted = true; el.volume = 0;
    attachSrc(el);
    var p = el.play();
    if (p && p.catch) p.catch(function () {});
  }

  var loadIO = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) attachSrc(en.target); });
      }, { rootMargin: '600px 1600px' })
    : null;

  var playIO = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.__vis = en.isIntersecting;
          if (en.isIntersecting) tryPlay(en.target);
          else if (!en.target.paused) en.target.pause();
        });
      }, { rootMargin: '80px 160px' })
    : null;

  function primeVideos(root) {
    $$('[data-muted-video]', root).forEach(function (el) {
      el.muted = true; el.defaultMuted = true; el.volume = 0;
      el.addEventListener('loadeddata', function () { if (el.__vis) tryPlay(el); });
      if (loadIO) { loadIO.observe(el); playIO.observe(el); }
      else tryPlay(el);
    });
  }

  /* ==========================================================================
     WIRING
     ========================================================================== */
  function init() {
    renderPress();
    renderExperts();
    renderUgc();
    renderIngredients();
    renderFaq();
    renderVs();

    tlGrid = $('[data-tl-grid]');
    tlLine = $('[data-tl-line]');
    tlFill = $('[data-tl-fill]');
    statsEl = $('[data-stats]');

    var mq = window.matchMedia('(max-width: 899px)');
    var onMq = function () { st.revMobile = mq.matches; st.revCount = 0; renderReviews(); };
    onMq();
    mq.addEventListener('change', onMq);

    syncPrices();
    syncCart();
    primeVideos(document);
    startDrTimer();
    startRotTimer();

    /* delegated clicks */
    document.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('[data-menu-open]'))) { setMenu(true); return; }
      if ((t = e.target.closest('[data-menu-close]'))) { setMenu(false); return; }
      if ((t = e.target.closest('[data-cart-open]'))) { setCart(true); return; }
      if ((t = e.target.closest('[data-checkout]'))) { e.preventDefault(); goToCheckout(t); return; }
      if ((t = e.target.closest('[data-cart-close]'))) { setCart(false); return; }
      if ((t = e.target.closest('[data-qty-inc]'))) { if (st.cart) { st.cart.qty += 1; syncCart(); } return; }
      if ((t = e.target.closest('[data-qty-dec]'))) { if (st.cart && st.cart.qty > 1) { st.cart.qty -= 1; syncCart(); } return; }
      if ((t = e.target.closest('[data-add-to-cart]'))) { addToCart(); return; }

      if ((t = e.target.closest('[data-gallery-prev]'))) { setSlide(st.img - 1); return; }
      if ((t = e.target.closest('[data-gallery-next]'))) { setSlide(st.img + 1); return; }
      if ((t = e.target.closest('[data-slide]'))) { setSlide(+t.getAttribute('data-slide')); return; }
      if ((t = e.target.closest('[data-rot]'))) { setRot(+t.getAttribute('data-rot')); startRotTimer(); return; }

      if ((t = e.target.closest('[data-bundle]'))) { st.bundle = +t.getAttribute('data-bundle'); syncPrices(); return; }
      if ((t = e.target.closest('[data-plan]'))) { st.plan = t.getAttribute('data-plan'); syncPrices(); return; }

      if ((t = e.target.closest('[data-info-toggle]'))) {
        var ii = +t.getAttribute('data-info-toggle');
        st.info = st.info === ii ? -1 : ii;
        $$('[data-info-toggle]').forEach(function (btn, k) {
          var open = k === st.info;
          $('[data-sign]', btn).textContent = open ? '−' : '+';
          btn.nextElementSibling.classList.toggle('is-open', open);
        });
        return;
      }

      if ((t = e.target.closest('[data-faq-toggle]'))) {
        var fi = +t.getAttribute('data-faq-toggle');
        st.faq = st.faq === fi ? -1 : fi;
        $$('[data-faq-toggle]').forEach(function (btn, k) {
          var open = k === st.faq;
          btn.setAttribute('aria-expanded', String(open));
          $('[data-sign]', btn).textContent = open ? '−' : '+';
          btn.nextElementSibling.classList.toggle('is-open', open);
        });
        return;
      }

      if ((t = e.target.closest('[data-rev-toggle]'))) {
        var base = revBase(), step = st.revMobile ? 2 : 6, cur = st.revCount || base;
        st.revCount = cur >= reviewData.length ? base : Math.min(cur + step, reviewData.length);
        renderReviews();
        return;
      }

      if ((t = e.target.closest('[data-vs-band]'))) {
        var gi = +t.getAttribute('data-vs-band');
        st.vsOpenIdx = st.vsOpenIdx === gi ? null : gi;
        renderVs();
        return;
      }

      if ((t = e.target.closest('[data-ing-open]'))) { openSheet(+t.getAttribute('data-ing-open')); return; }
      if ((t = e.target.closest('[data-sheet-close]'))) { closeSheet(); return; }
      if (e.target.closest('[data-sheet]') && !e.target.closest('[data-sheet-card]')) { closeSheet(); return; }
    });

    /* keyboard on the comparison bands (role="button") */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (st.sheetIng !== null) closeSheet();
        else if (st.cartOpen) setCart(false);
        else if (st.menuOpen) setMenu(false);
        return;
      }
      if ((e.key === 'Enter' || e.key === ' ') && e.target.hasAttribute && e.target.hasAttribute('data-vs-band')) {
        e.preventDefault();
        var gi = +e.target.getAttribute('data-vs-band');
        st.vsOpenIdx = st.vsOpenIdx === gi ? null : gi;
        renderVs();
      }
    });

    /* Content guard: no right-click, no drag, no text selection or copy anywhere
       inside the PDP. Bound to the .mo-pdp root rather than document so the
       theme's header, footer and cart drawer keep normal behaviour — checkout
       still needs copyable discount codes and order numbers.
       Friction, not protection: view-source, DevTools and screenshots all still
       work. See the note in pdp.css. */
    var root = $('.mo-pdp') || document.body;
    var block = function (e) { e.preventDefault(); };
    ['contextmenu', 'dragstart', 'copy', 'cut', 'selectstart'].forEach(function (type) {
      root.addEventListener(type, block);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measureTl(); updateTlFill(); });
    measureTl();
    onScroll();
    observeStats();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
